import { TABLE_TYPES } from '../../consts/tableTypes';
import { SimpleTable } from './tables/SimpleTable';
import { MultipleTable } from './tables/MultipleTable';
import { RankingTable } from './tables/RankingTable';
import { TurnoverTable } from './tables/Turnover';
import { GroupTable } from './tables/GroupTable';
import { useReportContextOptional } from '../../context/ReportContext';
import { GroupTurnoverTable } from './tables/GroupTurnoverTable';
import { SecuredBorrowingTable } from './tables/SecuredBorrowing';

export const NewTable = props => {
  const context = useReportContextOptional();

  const tableProps = {
    funds: props.funds ?? context?.funds,
    schema: props.schema ?? context?.schema,
    onChangeFund: props.onChangeFund ?? context?.onChangeFund,
    fundId: props.fundId ?? context?.currentDataKey,
    onAddColumn: props.onAddColumn ?? context?.addRow,
    onDeleteColumn: props.onDeleteColumn ?? context?.onDeleteRow,

    ...props
  };

  switch (props.tableType) {
    case TABLE_TYPES.SIMPLE:
      return <SimpleTable {...tableProps} />;

    case TABLE_TYPES.MULTIPLE:
      return <MultipleTable {...tableProps} />;

    case TABLE_TYPES.RANKING_TABLE:
      return <RankingTable {...tableProps} />;

    case TABLE_TYPES.TURNOVER:
      return <TurnoverTable {...tableProps} />;

    case TABLE_TYPES.GROUP:
      return <GroupTable {...tableProps} />;

    case TABLE_TYPES.GROUP_TURNOVER:
      return <GroupTurnoverTable {...tableProps} />;

    case TABLE_TYPES.SECURED_BORROWING:
      return <SecuredBorrowingTable {...tableProps} />;

    default:
      return <SimpleTable {...tableProps} />;
  }
};
